const Toaster = {
  NetworkErr: "Check your Internet connection -H",
  RepeatedBidMsg: "दोहराया बोली.",
  DeSelectedBids: "पहले चयनित बोलियों को अचयनित कर दिया गया है.",
  NoBidAvailable: "उपलब्ध बोलियों से अधिक का चयन नहीं कर सकते हैं.",
  BidSubmitted: "बोलियां सफलतापूर्वक सबमिट की गईं.",
  UpdateProfile: "आपकी प्रोफ़ाइल सफलतापूर्वक अपडेट की गई.",
  UpcomingAuctionMsg: "यह नीलामी अभी तक लाइव नहीं है!!",
  BuyBidsMsg: "आपके पास पर्याप्त बोलियां नहीं हैं.",
}

const HomePage = {
  Bid: "बोली",
  BidNWin: "बोली और विन",
  NoAuction: "कोई नीलामी उपलब्ध नहीं है",
  Live: "जीना",
  Upcoming: "आगामी",
  FreeBidMsg: "नि: शुल्क बोलियां आपके खाते में सफलतापूर्वक जुड़ गईं",
  OK: "ठीक",
  UserNotFound: "उपयोगकर्ता नहीं मिला",
  BuyBid: "बोलियां खरीदें",
}

const ProductDetailPage = {
  MyBids: "मेरी बोलियां", // My Bids Page
  AuctionNotLive: "नीलामी अभी तक नहीं जीती है!!",
  BidsRemaining: "शेष बोलियां",
  HowBidWork: "बोली कैसे काम करती है",
  KeyFeatures: "प्रमुख विशेषताऐं",
  PlaceBid: "बोली लगाना",
}

const PlaceBidPage = {
  ChooseRange: "रेंज चुनें",
  BidSelected: "बोली का चयन किया जाता है",
  ConfirmBid: "अपनी बोली की पुष्टि करें",
  SurePlaceBids: "क्या आप रखना चाहते हैं",
  CannotSelectBid: "आप बोली से अधिक का चयन नहीं कर सकते हैं",
  No: "नहीं",
  Yes: "हाँ",
  SelectBid: "बोली का चयन करें",
}

const MyBidsPage = {
  All: "सब -H",
  UniqueBids: "अद्वितीय बोलियां",
  RepeatedBids: "दोहराई गई बोलियां",
  LatestBids: "नवीनतम बोलियां",
  Selected: "चयनित -H",
  NoBidsPlaced: "कोई बोलियां नहीं रखी गईं",
  FirstBidPlaced: "कृपया अपनी पहली बोली यहां रखें",
}

const MyAccountPage = {
  MyAccount: "मेरा खाता",
  MobileNumber: "मोबाइल नंबर",
  Operator: "ऑपरेटर",
  Status: "स्थिति",
  BidsAvailable: "बोलियां उपलब्ध हैं", // Home page
  Bids: "बोलियां",
  SUBSCRIBED: "सदस्यता ली",
  UNSUBSCRIBE: "सदस्यता छोड़ दी गई",
  TRIAL: "परीक्षण",
  BidsExpiry: "बोलियां समाप्ति",
  BidsExpiryMsg: "बोलियां आज समाप्त हो जाएंगी",
  BUYBIDS: "बोलियां खरीदें",
  UnsubscribeMsg:
    "प्रिय उपयोगकर्ता, आपके पास अभी भी <1><0>{{count}}</0></1> बोलियां शेष हैं। क्या आप वाकई सेवा से सदस्यता समाप्त करना चाहते हैं।",
  UnsubscribeBids: "बोलियां सदस्यता छोड़ें",
  UnsubscribeBtnTxt: "हा, सदस्यता समाप्त करे",
  NoPlaceMyBids: "नहीं, मेरी बोलियां रखें",
  termAndConditions: "Term And Conditions",
}

const PastWinnersPage = {
  Winners: "विजेताओं",
  PastWinners: "पिछले विजेता",
  ListPastAuction: "पिछली नीलामी की सूची",
  NoWinners: "अभी तक कोई विजेता नहीं",
  WinningBid: "जीतने वाली बोली", //Winners Detail page
}

const ProfilePage = {
  Profile: "प्रोफाइल",
  FullName: "पूरा नाम",
  FullNamePlaceHolder: "अपना पूरा नाम लिखे",
  Email: "ईमेल आईडी",
  EmailPlaceHolder: "अपना ईमेल पता दर्ज करें",
  PhoneNumber: "फ़ोन नंबर",
  PhoneNumberPlaceHolder: "अपना दूरभाष क्रमांक दर्ज करें",
  ShippingAddress: "शिपिंग पता",
  ShippingAddressPlaceHolder: "अपना शिपिंग पता दर्ज करें",
}

const newTexts = {
  Testimonials: "प्रशंसापत्र",
  Logout: "लॉग आउट",
  Edit: "संपादन करना",
  MyWinnings: "मेरी जीत",
  DeliveryAddress: "डिलिवरी का पता",
  Email: "ईमेल",
  LiveBids: "लाइव बोलियां",
  ExpiredBids: "समाप्त बोलियां",
  AllBidsPlaced: "सभी बोली लगाई गई",
  AllBids: "सभी बोलियां",
  PlaceBids: "बोली लगाएं",
  StartBidding: "बोली लगाना शुरू करें",
  Youhave: "आपके पास",
  MyProfile: "मेरी प्रोफाइल",
  EditMyProfile: "मेरे प्रोफ़ाइल संपादित करे",
}

const hi = {
  translations: {
    ...HomePage,
    ...MyBidsPage,
    ...ProductDetailPage,
    ...PlaceBidPage,
    ...MyAccountPage,
    ...PastWinnersPage,
    ...ProfilePage,
    ...Toaster,
    ...newTexts,
  },
}

export default hi



// WEBPACK FOOTER //
// ./src/languages/hi.js